import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = [ "output" ]

  initialize() {
    this.visible = 0
  }

  connect() {
  }

  show({ params }) {
      this.safeFetch(params.url, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        // Use Turbo to process the stream
        Turbo.renderStreamMessage(html)
      })
      .then(() => this.outputTarget.focus())
  }

  hide(event) {
    event.preventDefault()
    event.stopPropagation()
    this.outputTarget.innerHTML=''
  }
}
